(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('FullStatsService', FullStatsService);
    
    FullStatsService.$inject = ['$http', '$q', 'ReportXlsService'];

    function FullStatsService($http, $q, ReportXlsService) {

        var service = {
            getAvailable: getAvailable,
            executeFullStats: executeFullStats,
            generateFullStatsXls: generateFullStatsXls,
        };
        var requestUrl = 'api/full-stats';
        return service;

        function getAvailable() {
            return $http.get(requestUrl + '/available').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function executeFullStats(obj) {
            return $http.post(requestUrl + '/execute-full-stats', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
        
        function generateFullStatsXls(obj) {
            ReportXlsService.generateExcelFile(obj, requestUrl + '/generate-xls-report', 'statistics_');
        }

    }
})();
